import { Link, isRouteErrorResponse, useRouteError } from "react-router";
import { Compass } from "lucide-react";
import { Button, EmptyState, ErrorState } from "@academia-hub/ui";
import { errorStateProps } from "../../lib/api-client.js";

/** Catch-all for an unknown path inside the signed-in app (instead of the router's raw error screen). */
export function NotFoundPage() {
  return (
    <EmptyState
      icon={Compass}
      title="Page not found"
      description="This address doesn't match any page. It may have been mistyped, or the link may be out of date."
      action={
        <Button asChild>
          <Link to="/">Go to home</Link>
        </Button>
      }
    />
  );
}

/** Route `errorElement`: a friendly screen for an unexpected render/loader error rather than a stack trace. */
export function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6">
        <NotFoundPage />
      </div>
    );
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <ErrorState
        title="Something went wrong"
        description="The page hit an unexpected error. Reloading usually fixes it; if it keeps happening, tell your administrator what you were doing."
        onRetry={() => window.location.reload()}
        {...errorStateProps(error)}
      />
    </div>
  );
}
